var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [_c("banner-ad"), _c("main-content")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-144e8ad4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-144e8ad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/services/fms.vue
// module id = bnUm
// module chunks = 15